import SvgCurve from './Curve';
import SvgGauge from './Gauge';
import SvgMap from './Map';
import SvgMetric from './Metric';
import SvgPichart from './Piechart';
import SvgTable from './Table';


export { SvgCurve, SvgGauge, SvgMap, SvgMetric, SvgPichart, SvgTable };
